import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PaymentService, Receipt } from '../payment.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.css'],
    standalone: false
})
export class SuccessComponent implements OnInit {

  @ViewChild('pdfContent') pdfContent: ElementRef;
  receipt: Receipt;
  emailSent: boolean = false;
  fileDownload: boolean = false;

  constructor(private route: ActivatedRoute, private payService: PaymentService){
  }

  async emailReceipt(){
    this.emailSent = true;
    let result: boolean = await this.payService.emailPdf(this.pdfContent);
    if(result){
      setTimeout(() =>{
        this.emailSent = false;
      }, 5000);
    }
  }
  downloadReceipt(){
    this.fileDownload = true;
    this.payService.downLoadReceipt(this.pdfContent);
    setTimeout(() =>{
      this.fileDownload = false;
    }, 5000);
  }

  ngOnInit(): void {
   
    //this.payService.getSubInfo  
    
    this.route.queryParams.subscribe(async params =>{
      let sessionId: string = params['session_id'];
      if(sessionId){
        this.receipt = await this.payService.getReceipt(sessionId);
      }
     
    });
       
  }

}
